<template>
  <div>
    <q-toolbar class="bg-primary text-white shadow-2">
      <q-btn
        flat
        align="left"
      >
        <q-img
          @click="goToHome"
          src="../assets/DigiPenLogoWhite.png"
          style="width: 250px; height: 40px"
        ></q-img>
      </q-btn>
      <q-tabs
        align="center"
        no-caps
      >
        <q-route-tab
          v-if='hasRoles("R&D", "HRL")'
          name="studentLanding"
          label="Student Landing"
          to="/studentLanding"
        />
        <q-route-tab
          v-if='hasRoles("HRL", "OTHER-STAFF")'
          name="complexes"
          label="Complexes"
          to="/complexes"
        />
        <q-route-tab
          v-if='hasRoles("HRL", "OTHER-STAFF")'
          name="sessions"
          label="Sessions"
          to="/sessions"
        />
        <q-route-tab
          v-if='hasRoles("HRL", "OTHER-STAFF")'
          name="applications"
          label="Applications"
          to="/applications"
        />
        <!-- @todo Change to STUDENT and K12-STUDENT role -->
        <q-route-tab
          v-if='
          hasRoles("STUDENT", "K12-STUDENT"
          , "RESIDENT-ASSISTANT"
          , "HRL"
          )'
          name="applicationForm"
          label="Application Form"
          to="/create-application"
        />
        <q-route-tab
          v-if='hasRoles("HRL", "R&D")'
          name="users"
          label="Users"
          to="/users"
        />
        <q-route-tab
          v-if='hasRoles("HRL","R&D")'
          name="placements"
          label="Placements"
          to="/placements"
        />
        <q-route-tab
          v-if='hasRoles("HRL","R&D")'
          name="emails"
          label="Emails"
          to="/emails"
        />
      </q-tabs>

      <q-space />
      <q-chip
        v-if="user.isImpersonating"
        color="warning"
        text-color="black"
        icon="visibility"
      >
        Impersonating {{ user.username }}
      </q-chip>
      <q-chip
        color="primary"
        text-color="white"
        icon="account_circle"
      >
        {{ user.email }}
      </q-chip>
      <q-btn
        v-if="user.isImpersonating"
        color='warning'
        text-color="black"
        no-caps
        size='sm'
        icon="visibility_off"
        class="q-mr-xs"
        @click='stopImpersonating'
      >
        Exit Impersonation
      </q-btn>
      <q-btn
        v-else-if='hasRoles("HRL","R&D")'
        color='secondary'
        text-color="black"
        no-caps
        size='sm'
        icon="visibility"
        class="q-mr-xs"
        @click='showImpersonateDialog = true'
      >
        Impersonate
      </q-btn>
      <q-btn
        color='secondary'
        text-color="black"
        no-caps
        size='sm'
        icon="logout"
        @click='logout'
      >
        Sign Out
      </q-btn>
      <q-dialog v-model="showImpersonateDialog">
        <q-card style="min-width: 350px">
          <q-card-section>
            <div class="text-h6">
              Impersonate User
            </div>
          </q-card-section>
          <q-card-section class="q-pt-none">
            <q-select
              v-model="impersonateUsername"
              :options="usernameOptions"
              use-input
              fill-input
              hide-selected
              input-debounce="0"
              label="Username"
              autofocus
              @filter="usernameFilter"
              @keyup.enter="submitImpersonate"
            />
          </q-card-section>
          <q-card-actions align="right">
            <q-btn
              flat
              label="Cancel"
              color="secondary"
              v-close-popup
            />
            <q-btn
              flat
              label="Impersonate"
              color="primary"
              :disable="!impersonateUsername"
              @click="submitImpersonate"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
      <!-- <div v-if="loginCredentials.loggedIn === true">
        {{ loginCredentials.email }}
        <q-btn
          @click="postLogout"
          flat
          round
          dense
          icon="logout"
        />
      </div>
      <div v-else>
        <q-btn
          to="Login"
          flat
          label="Login"
          no-caps
        />
        <q-btn
          to="Register"
          flat
          label="Register"
          no-caps
        />
      </div> -->
    </q-toolbar>
  </div>
</template>

<script>
import { ref } from 'vue';
import useAuth from '@/hooks/auth';
import useUser from '@/hooks/user';

export default {
  setup() {
    const {
      user, logout, hasRoles, impersonate, stopImpersonating,
    } = useAuth();
    const { getAllUsernames } = useUser();

    const showImpersonateDialog = ref(false);
    const impersonateUsername = ref(null);
    const usernameOptions = ref([]);
    let usernameList = null;

    const usernameFilter = async (val, update) => {
      if (usernameList === null) {
        usernameList = (await getAllUsernames()) || [];
      }
      update(() => {
        const needle = val.toLowerCase();
        usernameOptions.value = usernameList.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1,
        );
      });
    };

    const submitImpersonate = async () => {
      if (!impersonateUsername.value) {
        return;
      }
      showImpersonateDialog.value = false;
      await impersonate(impersonateUsername.value);
    };

    return {
      user,
      logout,
      hasRoles,
      stopImpersonating,
      showImpersonateDialog,
      impersonateUsername,
      usernameOptions,
      usernameFilter,
      submitImpersonate,
    };
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
  },
};
</script>
